import styled from "styled-components";
import colors from "../../../../../core/styles/colors";
import sizes from "../../../../../core/styles/sizes";

export const EntranceExamsListContainer = styled.div`
  width: 100%;
  min-height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media all and (${sizes.mobile}) {
    height: calc(100% - 200px);
    padding: 160px 0 40px 0;
    justify-content: space-between;
  }
`;

export const EntranceExamsListContent = styled.div`
  width: 100%;

  h1 {
    width: calc(100% - 64px);
    padding: 0 32px;
    margin: 0;
  }

  @media all and (${sizes.mobile}) {
    width: calc(100% - 96px);
    background: ${colors.white.general};
    border-radius: 10px;
    padding: 25px 32px;
  }
`;

export const EntranceExamsList = styled.div`
  width: calc(100% - 16px);
  padding: 24px 8px;
  max-height: calc(55vh - 24px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media all and (${sizes.mobile}) {
    height: fit-content;
    max-height: 50vh;
  }
`;

export const ExamLevelSection = styled.section`
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(auto-fit, 250px);
  grid-gap: 16px;

  > h2 {
    grid-column: 1 / -1;
    width: 100%;
    padding: 0;
    box-sizing: border-box;
    text-align: center;
  }

  @media all and (max-width: 570px) {
    grid-template-columns: 1fr;
  }
`;

export const ExamCard = styled.div<{ $isPassed: boolean }>`
  ${(props): string =>
    props.$isPassed
      ? `
    > div {
      background: rgba(48, 160, 0, 0.12);
      cursor: default;
      pointer-events: none;

      &:hover {
        background: rgba(48, 160, 0, 0.12);

        b {
          color: ${colors.black.general};
        }

        p {
          color: ${colors.green.general};
        }
      }
    }
  `
      : ""}
`;

export const ExamCardContent = styled.div`
  min-height: inherit;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;

  b {
    font-family: Gilroy, serif;
    font-weight: 300;
    font-size: 18px;
    line-height: 20px;
    color: ${colors.black.general};
  }
`;

export const ExamCardStatus = styled.p<{ $isPassed: boolean }>`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: Gilroy, serif;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  color: ${(props): string => (props.$isPassed ? colors.green.general : colors.gray.gray300)};

  svg {
    width: 12px;
    height: 12px;
    flex-shrink: 0;

    path {
      fill: ${colors.green.general};
    }
  }
`;
